import { z } from 'zod';
import { emailSchema, patchableSchema, usPhoneSchema, uuidSchema } from './common.js';
export const VENDOR_PHONE_TYPES = ['office', 'mobile', 'whatsapp', 'fax', 'other'];
export const VENDOR_EMAIL_TYPES = [
    'general',
    'ordering',
    'support',
    'billing',
    'sales',
    'other',
];
const nullableText = (max) => z.string().trim().max(max).nullable().default(null);
export const vendorPhoneSchema = z.object({
    type: z.enum(VENDOR_PHONE_TYPES),
    number: usPhoneSchema,
});
export const vendorEmailSchema = z.object({
    type: z.enum(VENDOR_EMAIL_TYPES),
    address: emailSchema,
});
/** One person (or desk) at the vendor, with any number of typed phones and
 *  typed emails. Stored as a jsonb array on the vendor row. */
export const vendorContactSchema = z.object({
    name: nullableText(150),
    role: nullableText(100),
    phones: z.array(vendorPhoneSchema).max(10).default([]),
    emails: z.array(vendorEmailSchema).max(10).default([]),
});
export const createVendorSchema = z.object({
    name: z.string().trim().min(1).max(150),
    contacts: z.array(vendorContactSchema).max(20).default([]),
    orderUrl: z.url().max(500).nullable().default(null),
    address: z.string().trim().max(500).nullable().default(null),
    notes: z.string().trim().max(2000).nullable().default(null),
    isActive: z.boolean().default(true),
});
/** Patchable, not partial — see {@link patchableSchema}. Editing a name must
 *  not blank the contacts, address and notes the caller never sent. */
export const updateVendorSchema = patchableSchema(createVendorSchema);
export const vendorSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    contacts: z.array(vendorContactSchema),
    orderUrl: z.string().nullable(),
    address: z.string().nullable(),
    notes: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.iso.datetime(),
});
export const vendorListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    q: z.string().trim().max(200).optional(),
    isActive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((v) => (typeof v === 'boolean' ? v : v === 'true'))
        .optional(),
});
//# sourceMappingURL=vendor.js.map